import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

import Collapse from './module/Collapse.js'
import User from './module/User.js'
import Logo from './module/Logo.js'
import DataSource from './module/DataSource.js'
import IndustyChecked from "./module/IndustyChecked";
import MacroChecked from "./module/MacroChecked";
import ChartRefush from "./module/ChartRefush";
import common from './module/common'
import MobileStatus from "./module/MobileStatus";
import v2Permission from "./module/v2Permission";
import ShowIndex from "./module/ShowIndex";
import Fta from './module/ftaModule'
import brpaModule from "@/store/module/brpaModule";
import CompanyStatus from './module/CompanyStatus'; // 2022.5.20
import brandMoudle from "@/store/module/brandModule";


export default new vuex.Store({
  state: {
    screenWidth:"",
    screenHeight:"",
    navScroll:"",
    footerShow:true,
    hasFooter:true,
    userInfo: {
      group_id: '',
      email: '',
      mobile: '',
    }
  },
  mutations: {
    group_id(state, value) {
      state.group_id = value
      state.userInfo.group_id = value
    },
    userInfo(state, value) {
      state.userInfo = Object.assign(state.userInfo, value)
    },
  },
  action: {

  },
  modules: {
    Collapse,
    User,
    Logo,
    DataSource,
    IndustyChecked,
    MacroChecked,
    ChartRefush,
    common,
    MobileStatus,
    v2Permission,
    ShowIndex,
    Fta,
    brpaModule,
    CompanyStatus,
    brandMoudle
  }
})
